import { render, staticRenderFns } from "./Origem.vue?vue&type=template&id=0c7aace8"
import script from "./Origem.vue?vue&type=script&lang=js"
export * from "./Origem.vue?vue&type=script&lang=js"
import style0 from "./Origem.vue?vue&type=style&index=0&id=0c7aace8&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports